import { createContext, useContext, useState, useEffect } from "react";
import type { ReactNode } from "react";
import { useGetCurrentServerTime } from "@oneapp/data";
import { setSyncedTime, isClockSynced } from "../../../shared/serverClock";

const ServerClockContext = createContext(false);

export function ServerClockProvider({ children }: { children: ReactNode }) {
  const [isSynced, setIsSynced] = useState(isClockSynced);
  const { data, dataUpdatedAt } = useGetCurrentServerTime({
    request: { clientName: "oneCms" },
  });

  useEffect(() => {
    if (!data || !dataUpdatedAt) return;
    const dateStr = data.current_datetime;
    const serverMs = new Date(
      dateStr.endsWith("Z") ? dateStr : dateStr + "Z",
    ).getTime();
    setSyncedTime(serverMs + (Date.now() - dataUpdatedAt));
    setIsSynced(true);
  }, [data, dataUpdatedAt]);

  return (
    <ServerClockContext.Provider value={isSynced}>
      {children}
    </ServerClockContext.Provider>
  );
}

export function useIsClockSynced(): boolean {
  return useContext(ServerClockContext);
}
